


































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VButton from '@/components/miniComponents/VButton.vue'
import { PartyRoom } from '@/types/PartyRoom'
import { ActionMethod, Mutation } from 'vuex'
import store from '@/store/RootState'

const partyRoomModule = namespace('partyRoom')
const userModule = namespace('user')

@Component({
  components: { VButton }
})
export default class EnterRoom extends Vue {
  @partyRoomModule.Getter('partyName') partyName!: string
  @partyRoomModule.State('partyRoom') partyRoom!: PartyRoom
  @partyRoomModule.Action('addUserToParty') addUserToParty!: any
  @userModule.Action('signIn') dispatchSignIn!: ActionMethod

  @userModule.Mutation('setDisplayName') setDisplayName!: Mutation<string>

  private name = ''

  mounted () {
    this.dispatchSignIn()
    this.name = store.state.user.user?.displayName || ''
    setTimeout(() => {
      if (!this.partyRoom) {
        this.$router.push('/')
      }
    }, 1000)
  }

  async joinParty () {
    if (this.name.length > 0) {
      this.setDisplayName(this.name)
      try {
        await this.addUserToParty()
        this.$router.push('/' + this.partyRoom.partyID)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
